import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_TARIFFA_ORARIA } from '../../data.const';
import {
  retrieveTariffaOrariaListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteTariffaOrariaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_TARIFFA_ORARIA),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true })),
        defer(() =>
          from(
            request({
              path: `tariffaOraria`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveTariffaOrariaListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_TARIFFA_ORARIA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false }))
      );
    })
  );

export default deleteTariffaOrariaEpic;
